import React from 'react';
import { Chart } from 'react-google-charts';

const CompliancePieChart = ({ data }) => {
    // Count occurrences of each resource
    const resourceCounts = {};

    data.forEach(item => {
        const resourceName = item.sResourceDisplayName;
        const count = item.sMobile_count || 1; // If sMobile_count is not present, default to 1
        resourceCounts[resourceName] = (resourceCounts[resourceName] || 0) + count;
    });

    // Prepare data for the pie chart
    const chartData = Object.entries(resourceCounts).map(([resourceName, count]) => [resourceName, count]);

    // Add header for the chart
    const chartHeader = [['Resource', 'Count'], ...chartData];

    return (
        <div>
            {
                // data.length > 1 ?
                    <div style={{
                        height: "50vh",
                        // border: "3px solid",
                    }}>
                        <div style={{ height: "100%", boxSizing: "border-box" }}>
                            <Chart
                                width={'100%'}
                                height="100%"
                                chartType="PieChart"
                                loader={
                                    <div className='d-flex align-items-center justify-content-center flex-column'
                        style={{
                            // border: "2px solid black",
                            // borderRadius: "15px",
                            height: '50vh'
                        }}>
                        Loading...
                    </div>
                                }
                                data={chartHeader}
                              options={{
                                backgroundColor:"#ddd",
                                title: 'Compliance',
                                
                              }}
                            />
                        </div>
                    </div>

                    // :
                    // <div className='d-flex align-items-center justify-content-center flex-column'
                    //     style={{
                    //         border: "2px solid black",
                    //         // borderRadius: "15px",
                    //         height: '50vh'
                    //     }}>
                    //     Loading...
                    // </div>
            }
        </div>
    );
};

export default CompliancePieChart;
